<template>
    <div>
        <el-tree
            v-if="popover === false"
            highlight-current
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="[1]"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            :class="defaultClass"
            @node-click="handleTreeNode"
        />

        <el-popover
            v-if="popover === true"
            placement="bottom"
            width="200"
            trigger="focus"
            @after-enter='treeShow'>
            <el-tree
                highlight-current
                node-key="id"
                ref="tree"
                :current-node-key="selectNodeId"
                :default-expanded-keys="[1]"
                :expand-on-click-node="false"
                :data="treeData"
                :props="defaultProps"
                :class="defaultClass"
                @node-click="handleTreeNode"
            />
            <el-input slot="reference" readonly v-model="popoverTreeLable"></el-input>
        </el-popover>
    </div>
</template>

<script>
    import { getArchiveTemplateTreeList, getArchiveTemplateInstanceTreeList } from '@/data-model';
    export default {
        name: 'ArchiveTemplateTree',
        data () {
            return {
                treeData: [],
                selectNodeId: 0,
                popoverTreeLable: ''
            };
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                type: [ Number, String ]
            },
            templateId: {
                type: String
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            },
            isInstance: { // 是否为实例
                type: Boolean,
                default: false
            },
            processInstanceId: { // 流程实例id
                type: String
            },
            defaultClass: {
                type: String,
                default: 'archive-template-tree-item'
            }
        },
        created () {
            this._initPage();
        },
        methods: {
            async _initPage () {
                await this._getTreeData();
                this._setSelectedNode();
            },
            async _getTreeData () {
                let archiveTemplateTreeList = [];
                if (this.data) {
                    archiveTemplateTreeList = this.data;
                } else {
                    if (this.isInstance) {
                        archiveTemplateTreeList = await getArchiveTemplateInstanceTreeList({rootId: this.rootId, templateId: this.templateId, processInstanceId: this.processInstanceId});
                    } else {
                        archiveTemplateTreeList = await getArchiveTemplateTreeList({rootId: this.rootId, templateId: this.templateId});
                    }
                }
                this.treeData = archiveTemplateTreeList;
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.popoverTreeLable = this.selectedNode.label;
                    this.selectNodeId = this.selectedNode.id;
                }
            },
            _refreshSelectedNode (node) {
                if (node) {
                    this.popoverTreeLable = node.title;
                    this.selectNodeId = node.value;
                }
            },
            handleTreeNode (data, node, tree) {
                this.popoverTreeLable = data.label;
                this.$emit('nodeClick', data, node, tree);
            },
            setTreeStatus () {
                this.$refs.tree.setCurrentNode(2);
            },
            treeShow () {
                // console.log('treeShow');
                // this.setTreeStatus();
                this.$emit('treeShow');
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ArchiveTemplateTree/ArchiveTemplateTree.vue